























































































import Vue from 'vue';
import { API } from '@/api';
import { mapActions, mapGetters } from 'vuex';

export default Vue.extend({
  props: {
    condominioInit: Array,
    disabled: Boolean,
  },
  data: () => ({
    openDialog: false,
      headers: [
        { text: 'Configuracion', value: 'name', sortable: false},
        { text: 'Dato', value: 'dato', sortable: false},
        { text: 'Accion', value: 'actions', sortable: false, width: 100},
      ],
      propiedades: [
        // { name: 'Apellido', dato: 'Velez' },
      ],
    dialog: false,
    editedIndex: -1,
    editedItem: {
      name: '',
      dato: '',
    },
    defaultItem: {
      name: '',
      dato: '',
    },
    contable: {
      descripcion: '',
      numCuenta: '',
      tipo: '',
    },
    pros: {},
    options: {
      itemsPerPage: -1,
    },
  }),
  methods: {
    async loadData() {
      try {
        this.loading = true;
        const admin = this.$store.getters.getAdmin;
        const condo = this.condominioInit[0];
        // const data = {admin: admin, condo: condominio};
        // console.debug('getCondoById data: %o', data);
        const result = await this.$store.dispatch('getProps', {admin, condo});
        console.debug('getProps response: %o', result);
        this.condominio = result;
        // this.total = result.totalElements;
        this.propiedades = [];
        for (const [k, v] of Object.entries(this.condominio)) {
          this.propiedades.push({name: k, dato: v});
          console.log('forEach: %o %o', k, v);
        }
        console.log('propertiesSize: ', this.propiedades.length);
      } catch (e) {
        console.debug('getCondoById error: %o', e);
        this.$toast.error(e);
      }
      this.loading = false;
    },
    editItem(item) {
      this.editedIndex = this.propiedades.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
      console.log('item', item);
    },

    async deleteItem(item) {
      console.log('item', item.name);
      try {
        const admin = this.$store.getters.getAdmin;
        const condo = this.condominioInit[0];
        const name = item.name;
        // console.log('deleteProps: ', name);
        const result = await this.$store.dispatch('deleteProps', {admin, condo, name} );
        console.debug('deleteProps: %o', result);
        this.$toast.success('Props Eliminado');
        this.loadData();
      } catch (e) {
        this.$toast.error(e.response.data.message);
      }
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    async save() {
      if (this.editedItem.name === '' || this.editedItem.dato === '' ) {
        this.$toast.error('Es necesario poner un número y nombre');
        return;
      }
      if (this.editedIndex > -1) { // Edit
        try {
          const admin = this.$store.getters.getAdmin;
          const condo = this.condominioInit[0];
          const prop = this.editedItem;
          // console.log('updateProps', this.editedItem);
          const result = await this.$store.dispatch('updateProps', {admin, condo, prop} );
          console.debug('updateProps: %o', result);
          this.$toast.success('Prop Editado');
          this.loadData();
        } catch (e) {
          this.$toast.error(e.response.data.message);
        }
      } else { // New
        try {
          this.editedItem.name = this.editedItem.name.trim();
          const admin = this.$store.getters.getAdmin;
          const condo = this.condominioInit[0];
          const prop = this.editedItem;
          const result = await this.$store.dispatch('addProps', {admin, condo, prop} );
          console.debug('addProps: %o', result);
          this.$toast.success('Props agregado');
          this.loadData();
        } catch (e) {
          this.$toast.error(e.response.data.message);
        }
      }
      this.AgregarContable();
      // console.log('Propiedades %o', this.editedItem);
      this.close();
    },
    async AgregarContable() {
      try {
        this.loading = true;
        const admin = this.$store.getters.getAdmin;
        const condo = this.condominioInit[0];
        this.contable.descripcion = this.editedItem.name;
        this.contable.numCuenta = this.editedItem.dato;
        this.contable.tipo = 'MAYOR';
        const contable = this.contable;
        const datos = {admin, condo, contable};
        console.log('datos: %o', datos);
        const result = await this.$store.dispatch('addContable', {datos} );
        console.debug('Respuesta addContable: %o', result);
        this.$toast.success('Cuenta contable agregada');
      } catch (e) {
        console.error(e);
        this.$toast.error(e.response.data.message);
      }
      this.loading = false;
      this.openDialog = false;
      this.$emit('reload', {});
    },
    async addBasics() {
      try {
        this.loading = true;
        const admin = this.$store.getters.getAdmin;
        const condo = this.condominioInit[0];
        const datos = {admin, condo};
        const result = await this.$store.dispatch('addBasics', {datos} );
        console.debug('Respuesta addBasics: %o', result);
        this.$toast.success('Cuentas base agregadas');
      } catch (e) {
        console.error(e);
        this.$toast.error(e.response.data.message);
      }
      this.loading = false;
      this.openDialog = false;
      this.$emit('reload', {});
    },
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item';
    },
  },
  watch: {
    openDialog() {
      if (this.openDialog) {
        console.log('inicio');
        this.loadData();
      }
    },
  },
});
